import { extend } from 'vee-validate';

extend('minNumber', {
	validate(value, { min }) {
		if (parseInt(value)  > min) {
			return true;
		  }  		
	},
	params: ['min'],
	message: 'Debe ser mayor a {min}'
});
extend('maxNumber', {
	validate(value, { max }) {
		if (parseInt(value) < max) {
			return true;
		  }  		
	},
	params: ['max'],
	message: 'Debe ser menor que {max}'
});
extend('minLength', {
	validate(value, { minlength }) {
		if (value.toString().length >= minlength) {
			return true;
		}  		
	},
	params: ['minlength'],
	message: 'Mínimo {minlength} caracteres'
});
extend('maxLength', {
	validate(value, { maxlength }) {
		if (value.toString().length <= maxlength) {
			return true;
		}  		
	},
	params: ['maxlength'],
	message: 'Máximo {maxlength} caracteres'
});
extend('required', {
	validate (value) {	
	  return {
		required: true,
		valid: ['', null, undefined].indexOf(value) === -1
	  };
	},
	computesRequired: true,
	message: 'Campo requerido'
  });
